import React, {FC} from 'react';

import {Icon} from '@optimaxdev/icons';
import classNames from 'classnames';

import {getCurrentUhcCookie} from 'libs/getCurrentUhcCookie/getCurrentUhcCookie';

import * as LfgIcon from './icons/lincolnLogo.svg';
import * as MediGoldIcon from './icons/mediGold.svg';
import * as SolsticeLogo from './icons/solstice.svg';
import * as SpecteraLogo from './icons/specteraLogo.svg';
import * as UhcLogo from './icons/uhcLogo.svg';

import s from './brandsLogo.scss';

type PropsType = {
    isFullColor?: boolean;
    brand: keyof typeof ICONS;
};

const ICONS = {
    LFG: LfgIcon,
    MEDIGOLD: MediGoldIcon,
    SOLSTICE: SolsticeLogo,
    SPECTERA: SpecteraLogo,
    UHC: UhcLogo,
};

const dynamicClasses: {[key: string]: string} = {
    lfg: s.lfg,
    medigold: s.medigold,
    solstice: s.solstice,
    spectera: s.spectera,
    uhc: s.uhc,
};

/**
 * Provides the logo for uhc users
 * @returns {JSX.Element} - return JSX component
 */
export const BrandsLogo: FC<PropsType> = ({brand = getCurrentUhcCookie(), isFullColor = false}) => {
    const Logo = ICONS[brand];

    return (
        <div
            className={classNames(
                s.wrap,
                isFullColor ? dynamicClasses[brand.toLocaleLowerCase()] : s.commonWhiteColor,
            )}
            data-testid="uhc-logo"
        >
            <Icon icon={Logo} width="100%" />
        </div>
    );
};
